import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';

import { fieldSet, setLabel, labelStyle } from './FieldSet.less';

const FieldSet = ({ label, labelDetailId, localeId, localeMessage, children, style = {} }) => (
  <div className={fieldSet} style={style}>
    <Row>
      <Col xs={12} sm={5} md={4}>
        <div className={setLabel}>{localeId ? localeMessage(localeId) : label || ''}</div>
        <div>
          <p className={labelStyle}>{labelDetailId && localeMessage(labelDetailId)}</p>
        </div>
      </Col>
      <Col xs={12} sm={6} smOffset={1} md={7} mdOffset={1}>
        {children}
      </Col>
    </Row>
  </div>
);

FieldSet.propTypes = {
  label: PropTypes.string,
  labelDetailId: PropTypes.string,
  localeId: PropTypes.string,
  localeMessage: PropTypes.func,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default FieldSet;
